<template>
    <transition name="logindialog">
        <div v-show="value" class="com-codics-hbb-order-dialog-body" @click="changeShow">
            <div class="com-codics-hbb-order-dialog-body-card" @click.stop="1">
                <el-carousel class="com-codics-hbb-order-dialog-body-card-carousel" height="400px">
                    <el-carousel-item v-for="(item, index) in lunboData" :key="index">
                        <el-image class="com-codics-hbb-order-dialog-body-card-carousel-img" :src="item"
                            fit="cover"></el-image>
                    </el-carousel-item>
                </el-carousel>
                <div class="com-codics-hbb-order-dialog-body-card-login-box">
                    <div class="com-codics-hbb-order-dialog-body-card-login-box-title">员工登录注册</div>
                    <div class="com-codics-hbb-order-dialog-body-card-login-box-input-box">
                        <div class="iconfont com-codics-hbb-order-dialog-body-card-login-box-input-box-icon">&#xe6aa;
                        </div>
                        <input type="text" v-model="logInfo.a"
                            class="com-codics-hbb-order-dialog-body-card-login-box-input com-codics-hbb-order-dialog-body-card-login-box-input-account"
                            placeholder="请输入您的手机号">
                    </div>
                    <div class="com-codics-hbb-order-dialog-body-card-login-box-input-box"
                        style="margin-top: 15px;padding-right: 45px !important;">
                        <div class="iconfont com-codics-hbb-order-dialog-body-card-login-box-input-box-icon">&#xe6ab;
                        </div>
                        <input :type="passType" v-model="logInfo.p"
                            class="com-codics-hbb-order-dialog-body-card-login-box-input com-codics-hbb-order-dialog-body-card-login-box-input-account"
                            placeholder="请输入您的密码">
                        <div class="iconfont com-codics-hbb-order-dialog-body-card-login-box-input-box-icon"
                            style="left: unset;right: 0;cursor: pointer;"
                            @click="passType = (passType == 'password' ? 'text' : 'password');"
                            v-html="passType == 'password' ? '&#xe6af;' : '&#xe6b0;'">
                        </div>
                    </div>
                    <div class="com-codics-hbb-order-dialog-body-card-login-box-input-box"
                        style="margin-top: 15px;padding: 0 90px 0 15px;">
                        <input type="text" v-model="logInfo.v"
                            class="com-codics-hbb-order-dialog-body-card-login-box-input com-codics-hbb-order-dialog-body-card-login-box-input-account"
                            placeholder="请输入验证码">
                        <el-image class="com-codics-hbb-order-dialog-body-card-login-box-input-card-code"
                            :src="verifyImg" fit="fill" @click="changeVerifyFuc">
                            <div slot="error" class="image-slot"
                                style="height:fit-content;width: fit-content;position: absolute;margin: auto;top: 0;left: 0;right: 0;bottom: 0;"
                                @click="changeVerifyFuc">
                                <i class="el-icon-loading" v-show="verifyState"></i>
                            </div>
                        </el-image>
                        <div style="height: 100%;width: 90px;position: absolute;line-height: 46px;text-align: center;font-size: 12px;right: 0;top: 0;user-select: none;cursor: pointer;color: #AAA;"
                            v-show="!verifyState" @click="changeVerifyFuc(); verifyState = true;">加载验证码</div>
                    </div>
                    <div class="com-codics-hbb-order-dialog-body-card-login-box-line">
                        <el-checkbox v-model="logCheck" style="color: #AAA;">7天免登录</el-checkbox>
                        <a class="com-codics-hbb-order-dialog-body-card-login-box-line-pass"
                            href="https://qm.qq.com/q/VPQBQGwUUI">忘记密码？</a>
                    </div>
                    <div class="com-codics-hbb-order-dialog-body-card-login-btn" @click="userLoginFuc">登录/注册</div>
                </div>
            </div>
            <div class="com-codics-hbb-order-dialog-close" v-show="!lock"></div>
        </div>
    </transition>
</template>

<script>
import { mapState } from 'vuex';
import { changeVerify, userLogin } from '@/api';
import { setCookie, setCookieWithExp } from '@/utils/mycookie';
import { saveData, jumpTo, isPhone } from '@/utils/myutils';
export default {
    props: {
        lock: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        },
        height: {
            type: String,
            default: 'fit-content'
        },
        width: {
            type: String,
            default: '40%'
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            passType: 'password',
            logInfo: {
                a: '',
                p: '',
                v: '',
                e: 0
            },
            logCheck: false,
            verifyImg: '',
            verifyState: false,
            lunboData: ['https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/yasuo_hy_bj.webp']
        }
    },
    mounted() {

    },
    computed: {
        ...mapState(['userInfo'])
    },
    watch: {
        value(newVal, oldVal) {
            if (newVal) {
                this.changeVerifyFuc();
            }
        }
    },
    methods: {
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        changeShow(e) {
            if (this.lock) return;
            this.$emit('input', !this.value);
            e.stopPropagation();
            return false;
        },
        async userLoginFuc() {
            // if (!isPhone(this.logInfo.a)) {
            //     this.$message({
            //         showClose: true,
            //         message: '填写的手机号格式不正确！',
            //         type: 'warning'
            //     });
            //     return;
            // }
            if (this.logInfo.a == '') {
                this.$message({
                    showClose: true,
                    message: '填写的账号不能为空！',
                    type: 'warning'
                });
                return;
            }
            if (this.logInfo.p == '') {
                this.$message({
                    showClose: true,
                    message: '填写的密码不能为空！',
                    type: 'warning'
                });
                return;
            }
            if (this.logInfo.v == '') {
                this.$message({
                    showClose: true,
                    message: '填写的验证码不能为空！',
                    type: 'warning'
                });
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.logInfo.e = this.logCheck ? 168 : 2;
            let data = await userLogin(this.logInfo);
            loading.close();
            if (data.code == 200) {

                saveData("user-inf", JSON.stringify(data), this.logCheck ? 7 : (1 / 12));
                // 刷新仓库数据
                this.$store.dispatch('login');

                this.$message({
                    message: '账号登录成功！',
                    type: 'success'
                });

                if (this.userInfo?.user?.member == 0 || this.userInfo?.user?.member == -1) {

                    setTimeout(() => {

                        window.location.reload();

                    }, 300);

                } else {

                    this.userInfo?.user?.menus.forEach(item => {

                        if (item.child.length > 0) {

                            this.jumpToPage(item.child[0].title, {}, {});

                            window.location.reload();

                        }

                    });

                }

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async changeVerifyFuc() {
            let data = await changeVerify();
            if (data.code == 200) {
                this.verifyState = true;
                this.verifyImg = data.data;
            } else {
                this.$message.error(data.message);
            }
        },
    }
}
</script>

<style>
/* 弹窗体 */
.com-codics-hbb-order-dialog-body {
    height: 100%;
    width: 100%;
    transition: .3s;
    position: fixed;
    z-index: 1111;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(3px);
    /* -webkit-backdrop-filter: blur(3px); */
}

.com-codics-hbb-order-dialog-body-card {
    height: 400px;
    width: 900px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #FFF;
    pointer-events: all;
}

.com-codics-hbb-order-dialog-body-card-carousel {
    height: 400px;
    width: 50%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.com-codics-hbb-order-dialog-close {
    height: 22px;
    width: 22px;
    position: absolute;
    margin: auto;
    top: -450px;
    left: 0;
    right: -950px;
    bottom: 0;
    cursor: pointer;
}

.com-codics-hbb-order-dialog-close:hover::after {
    transform: rotate(225deg);
    background: rgba(255, 136, 0, 1);
}

.com-codics-hbb-order-dialog-close:hover::before {
    transform: rotate(315deg);
    background: rgba(255, 136, 0, 1);
}

.com-codics-hbb-order-dialog-close::before,
.com-codics-hbb-order-dialog-close::after {
    content: '';
    height: 22px;
    width: 1px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transform: rotate(45deg);
    background: rgba(255, 255, 255, 1);
    border-radius: .5px;
    transition: .3s;
}

.com-codics-hbb-order-dialog-close::after {
    transform: rotate(-45deg);
}

.com-codics-hbb-order-dialog-body-card-login-box {
    height: 400px;
    width: 50%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 35px 65px;
}

.com-codics-hbb-order-dialog-body-card-login-box-title {
    height: 32px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 32px;
    text-align: center;
    font-size: 30px;
    color: #333;
    font-weight: bolder;
    user-select: none;
}

.com-codics-hbb-order-dialog-body-card-login-box-input-box {
    height: 48px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 15px 0 45px;
    margin-top: 25px;
    border: 1px solid #DDD;
}

.com-codics-hbb-order-dialog-body-card-login-box-input {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    outline: none;
    border: none !important;
    color: #666;
}

.com-codics-hbb-order-dialog-body-card-login-box-input-box-icon {
    height: 46px;
    width: 45px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    line-height: 46px;
    text-align: center;
    color: #AAA;
    font-size: 15px;
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-hbb-order-dialog-body-card-login-box-input-card-code {
    height: 25px;
    width: 62.5px;
    position: absolute !important;
    margin: auto;
    right: 13.75px;
    top: 10.5px;
    box-sizing: border-box;
    cursor: pointer;
    color: #333;
    font-size: 11px;
}

.com-codics-hbb-order-dialog-body-card-login-box-line {
    height: 48px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 48px;
}

.com-codics-hbb-order-dialog-body-card-login-box-line-pass {
    height: 48px;
    width: fit-content;
    position: relative;
    float: right !important;
    line-height: 48px;
    text-align: center;
    font-size: 14px;
    text-decoration: none;
    color: #AAA;
    user-select: none;
    -webkit-user-drag: none;
    cursor: pointer;
}

.com-codics-hbb-order-dialog-body-card-login-btn {
    height: 46px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 46px;
    text-align: center;
    font-size: 14px;
    color: #FFF;
    background: #ea5b18;
    letter-spacing: 5px;
    user-select: none;
    -webkit-user-drag: none;
    cursor: pointer;
    transition: .3s;
}

.com-codics-hbb-order-dialog-body-card-login-btn:hover {
    background: #ff5100;
}

.com-codics-hbb-order-dialog-body-card-login-btn:active {
    background: #ac3f0d;
}

/* 定义进入和离开的过渡效果 */
.logindialog-enter-active,
.logindialog-leave-active {
    transition: .3s;
}

.logindialog-enter,
.logindialog-leave-to {
    opacity: 0;
}

@media (max-width:768px) {
    .com-codics-hbb-order-dialog-body-card-carousel {
        display: none !important;
    }
}
</style>